<template>
	<div class="service-default">
		<el-row class="header-title" type="flex" justify="space-between" align="middle">
			<div class="title-item">
				<div
					class="status"
					:class="
						(statusValue == 1 && 'huoyue') ||
						(statusValue == 2 && 'zanting') ||
						(statusValue == 3 && 'siwang')
					"
				>
					{{ formatStatusVal }}
				</div>
				<div class="customer-name">{{ serviceDetail.custName }}</div>
				<div class="cutStatus" @click="showCutStatus">
					切换状态
					<ig-icon name="qiehuanzhuangtai"></ig-icon>
				</div>
			</div>
			<div class="title-item title-info">
				<div class="sum">
					账户余额：
					<span v-if="serviceDetail.balance">{{ balance }}</span>
					<span v-else>0</span>
				</div>
				<el-button type="primary" :loading="superviseLoading" @click="setSupervise"
					>监测设置</el-button
				>
			</div>
		</el-row>
		<el-row type="flex" justify="start" align="middle" class="customer-info-list">
			<el-col :span="8" v-for="item in customerInfoList" :key="item.id">
				<span>{{ item.label }}：</span>
				<span :style="[item.valueSty]" @click="customerInfoClick(item)">{{ item.value }}</span>
			</el-col>
		</el-row>
		<sticky :stickyTop="0" :zIndex="999">
			<div class="date-switch">
				<!-- 日期选择器 -->
				<date-switch-selector
					:groups="timeSwitch"
					:lastDay="true"
					timeType="date"
					@reportData="getAllData"
				></date-switch-selector>
				<div>数据截止：{{ yesterday }}</div>
			</div>
		</sticky>

		<!-- 概况 -->
		<overview title="概况" :dataList="overviewList"></overview>

		<!-- 预警 -->
		<client-module class="overview" moduletitle="预警">
			<div slot="event" @click="skipLog">预警日志</div>
			<div class="displayFlex">
				<div class="pad10 warning-left">
					<div class="number">{{ warningTotal }}</div>
					<div class="title">待解决预警总数</div>
				</div>
				<div class="pad10 warning-right">
					<el-card v-for="item in warningList" :key="item.id" shadow="hover">
						<div @click="skipWarning(item.id)">
							<div class="number">{{ item.value }}</div>
							<div class="title">{{ item.label }}</div>
							<div class="hint">点击查看</div>
						</div>
					</el-card>
				</div>
			</div>
		</client-module>

		<!-- 预算 -->
		<client-module class="overview" moduletitle="预算">
			<div class="displayFlex">
				<div class="pad10 warning-left">
					<div class="data-box">
						<div class="title">预算</div>
						<div class="number">
							<span>{{ budgetAmountMicros }}</span>
							<span class="unit" v-if="budgetAmountMicros && budgetAmountMicros != '-'">/天</span>
						</div>
						<div class="bottom">
							<div class="rate">使用率：{{ usageRate }}</div>
							<div class="period">上一周期：{{ lastUsageRate }}</div>
						</div>
					</div>
				</div>
				<div :span="16" class="pad10 warning-right">
					<data-list
						style="width: 90%;"
						height="220"
						:columns="budgetColumns"
						:data="data"
						:loading="loading"
					></data-list>
				</div>
			</div>
		</client-module>

		<!-- 概况 -->
		<overview title="效果" :dataList="resultList" :showperiod="false"></overview>

		<!-- 监测编辑 -->
		<monitoring-rules
			ref="rules"
			:serviceId="serviceDetail.serviceId"
			:showDoalog="showDoalog"
			:attributes="attributes"
			:formData="formData"
			:groups="groups"
			:columns="columns"
			@saveCost="saveCost"
			@close:dialogVisible="val => (showDoalog = val)"
		></monitoring-rules>
		<!-- 切换状态 -->
		<el-dialog
			:visible.sync="showCutStatusVal"
			:before-close="cancelStatus"
			title="状态切换"
			width="30%"
		>
			<div class="statusDialog">
				<div class="hint">客户状态切换为：</div>
				<sky-select
					style="width: 100px;"
					:value="statusValue"
					:options="customerStatus"
					:clearable="false"
					size="small"
					@change="selectChange"
				></sky-select>
			</div>

			<div slot="footer" class="dialog-footer">
				<el-button @click="cancelStatus">取 消</el-button>
				<el-button type="primary" @click="changeStatus">保存</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import skySelect from '@/components/iglobalwin/formComponents/sky-select.vue';
import { customerStatus, warningPriority, warningStatus, timeSwitch } from '@/common/dictionary.js';
import clientModule from '@/components/client/clientModule/clientModule.vue';
import components from '@/components/iglobalwin/formComponents/index.js';
import { validRequired } from '@/common/elementValid.js';
import googleAds from '@/backend/services/googleAds/googleAds.js';
import api from '@/backend/apiConfig/apiConfig';
import messageSwitch from '@/components/customer/messageSwitch';
import inputInsertion from '@/components/googleAdsCom/inputInsertion.vue';
import monitoringRules from '@/components/googleAdsCom/monitoringRules';
import dateSwitchSelector from '@/components/dateSwitchSelector/dateSwitchSelector';
import filters from '@/mixins/filters.js';
import listPageCreate from '@/mixins/listPageCreate';
import overview from '@/components/googleAdsCom/overview';
import googleAdsIput from '@/components/googleAdsCom/googleAdsIput';
import sticky from '@/components/sticky';
import { getDateRegion } from '@/common/util.js';
const dataList = listPageCreate({
	searchConfig: {
		api: api.googleAds.serviceAdvertising,
		method: 'POST',
		config: {
			timeout: 30000,
		},
	},
	getQuery(obj, that) {
		return _.assign(obj, {
			...that.budgetParam,
		});
	},
});

export default {
	mixins: [dataList],
	data() {
		return {
			statusValue: '',
			tempStatus: '',
			customerStatus: customerStatus,
			showDoalog: false,
			id: '',
			serviceDetail: '',
			customerInfoList: [],
			warningTypeList: [],
			attributes: {
				width: '50%',
				destroy: true,
				title: '监测设置',
			},
			formData: {},
			groups: {},
			columns: [],
			column: {},
			openFlag: '',
			ruleVal: [],
			ruleVals: {},
			inquiryConsuleData: {},
			overviewList: [],
			warningList: [],
			warningTotal: '',
			budgetParam: {},
			budgetColumns: [],
			resultList: [],
			superviseLoading: false,
			timeSwitch,
			showCutStatusVal: false,
			disabled: true,
		};
	},
	computed: {
		budgetAmountMicros() {
			return filters.filters.rmb(this.serviceDetail.kpi);
		},
		usageRate() {
			return filters.filters.jojint(this.inquiryConsuleData.usageRate);
		},
		lastUsageRate() {
			return filters.filters.jojint(this.inquiryConsuleData.lastUsageRate);
		},
		balance() {
			return filters.filters.rmb(this.serviceDetail.balance);
		},
		formatStatusVal() {
			let val = this.statusValue;
			switch (val) {
				case 1:
					return '活跃';
				case 2:
					return '暂停';
				case 3:
					return '死亡';
				default:
					return '';
			}
		},
		yesterday() {
			let date = getDateRegion('DAY').split('至');
			return date[0];
		},
	},
	mounted() {
		this.requestDate();
	},
	methods: {
		requestDate() {
			this.id = this.$route.query.serviceId;
			this.getServiceDetail();
			this.getWarningType();
			this.setcolumns();
		},
		// 获取服务单详情
		async getServiceDetail() {
			try {
				let { id } = this;
				let res = await googleAds.serviceDetail(id);
				this.serviceDetail = res.data;
				this.statusValue = res.data.activeStatus;
				this.tempStatus = res.data.activeStatus;
				this.setcustomerInfoList(res.data);
			} catch (error) {
				this.setcustomerInfoList();
			}
		},
		async getAllData(param) {
			let { selecttimetype, startDate, endDate } = param;
			let id = this.$route.query.serviceId;
			let value = {
				startDate,
				endDate,
				id,
				searchType: selecttimetype,
			};
			this.getserviceAdvertising(value);
			this.getserviceInquiryConsule(value);
		},
		// 配置预算信息
		async getserviceAdvertising(param) {
			this.budgetParam = param;
			this.budgetColumns = [
				{
					bind: 'campaignName',
					type: 'mapping',
					mapType: 'text',
					trigger: 'hover',
				},
				{
					label: '预算',
					bind: 'budgetAmountMicros',
					type: 'percentage',
					dataStyle(val) {
						return filters.filters.rmb(val);
					},
				},
				{
					label: '消耗',
					bind: 'exchangeRateCost',
					type: 'percentage',
					dataStyle(val) {
						return filters.filters.rmb(val);
					},
				},
				{
					label: '使用率',
					bind: 'useRate',
					type: 'percentage',
					dataStyle(val) {
						return filters.filters.jojint(val);
					},
				},
				{
					label: '上一周期消耗',
					bind: 'lastExchangeRateCost',
					type: 'percentage',
					dataStyle(val) {
						return filters.filters.rmb(val);
					},
				},
				{
					label: '上一周期使用率',
					bind: 'lastUseRate',
					type: 'percentage',
					dataStyle(val) {
						return filters.filters.jojint(val);
					},
				},
			];
			this.query();
		},
		//
		async getserviceInquiryConsule(param) {
			let res = await googleAds.serviceInquiryConsule(param);
			let val = res.data;
			this.inquiryConsuleData = res.data;
			this.warningTotal = filters.filters.thousands(val.remindStatis && val.remindStatis.total);
			this.overviewList = [
				{
					id: 1,
					title: '询盘数',
					value: filters.filters.thousands(val.inquiryNum),
					period: filters.filters.thousands(val.lastInquiryNum),
					valueUnit: '个',
					periodUnit: '个',
					efficiency: filters.filters.jojint(val.inquiryChangeRate),
					iconData: morezero(val.inquiryChangeRate),
				},
				{
					id: 2,
					title: '询盘成本',
					value: val.inquiryCost == '∞' ? '￥∞' : filters.filters.rmb(val.inquiryCost),
					period: filters.filters.rmb(val.lastInquiryCost),
					valueUnit: '/个',
					periodUnit: '/个',
					efficiency: filters.filters.jojint(val.inquiryCostChangeRate),
					iconData: morezero(val.inquiryCostChangeRate),
				},
				{
					id: 3,
					title: '账户消耗',
					value: filters.filters.rmb(
						val.googleAdsBaseReport && val.googleAdsBaseReport.exchangeRateCost
					),
					period: filters.filters.rmb(
						val.googleAdsBaseReport && val.googleAdsBaseReport.comparisonExchangeRateCost
					),
					efficiency: filters.filters.jojint(
						val.googleAdsBaseReport && val.googleAdsBaseReport.exchangeRateCostRingRatio
					),
					iconData: morezero(
						val.googleAdsBaseReport && val.googleAdsBaseReport.exchangeRateCostRingRatio
					),
				},
			];

			let value = val.remindStatis;
			this.warningList = [
				{
					id: '1',
					label: '第一优先级',
					value: filters.filters.thousands(value && value.gradeOneNum),
				},
				{
					id: '2',
					label: '第二优先级',
					value: filters.filters.thousands(value && value.gradeTwoNum),
				},
				{
					id: '3',
					label: '第三优先级',
					value: filters.filters.thousands(value && value.gradeThreeNum),
				},
			];
			let data = val.googleAdsBaseReport;
			this.resultList = [
				{
					id: 3,
					title: '展示次数',
					value: filters.filters.thousands(data && data.impressions),
					efficiency: filters.filters.jojintAbs(data && data.impressionsRingRatio),
					iconData: morezero(data && data.impressionsRingRatio),
					message: message(data && data.impressionsRingRatio),
				},
				{
					id: 4,
					title: '点击次数',
					value: filters.filters.thousands(data && data.clicks),
					efficiency: filters.filters.jojintAbs(data && data.clickNumberRingRatio),
					iconData: morezero(data && data.clickNumberRingRatio),
					message: message(data && data.clickNumberRingRatio),
				},
				{
					id: 5,
					title: '点击率',
					value: data && data.clickRate,
					valueUnit: '%',
					efficiency: filters.filters.jojintAbs(data && data.clickRingRatio),
					iconData: morezero(data && data.clickRingRatio),
					message: message(data && data.clickRingRatio),
				},
				{
					id: 6,
					title: '转化率',
					value: data && data.conversionRate,
					valueUnit: '%',
					efficiency: filters.filters.jojintAbs(data && data.conversionRateRingRatio),
					iconData: morezero(data && data.conversionRateRingRatio),
					message: message(data && data.conversionRateRingRatio),
				},
			];

			function morezero(val) {
				val = parseFloat(val);
				if (val >= 0) return 'shangsheng';
				if (val < 0) return 'xiajiang';
			}

			function message(val) {
				val = parseFloat(val);
				if (val >= 0) return '相比上一周期增加';
				if (val < 0) return '相比上一周期减少';
			}
		},
		// 获取预警类别列表
		async getWarningType() {
			let res = await googleAds.warningTypeList();
			this.warningTypeList = res.data;
			this.setgroups();
		},
		setcustomerInfoList(val = {}) {
			this.customerInfoList = [
				{
					id: 1,
					label: '服务人员',
					value: val.serviceStaffName || '-',
				},
				{
					id: 2,
					label: 'CID',
					value: val.cid || '-',
				},
				{
					id: 3,
					label: '订单号',
					value: val.orderCode || '-',
				},
				{
					id: 4,
					label: '服务单号',
					value: val.serviceCode || '-',
				},
				{
					id: 5,
					label: 'CID绑定时间',
					value: val.accountOpenTime || '-',
				},
				{
					id: 7,
					label: '推广网站',
					value: val.domain || '-',
					valueSty: {
						color: '#409eff',
						cursor: 'pointer',
						'user-select': 'none',
					},
				},
			];
			let status = this.statusValue;
			if (status == 2) {
				this.customerInfoList.push({
					id: 6,
					label: '暂停时间',
					value: val.statusChangeTime || '-',
				});
			}

			if (status == 3) {
				this.customerInfoList.push({
					id: 6,
					label: '死亡时间',
					value: val.statusChangeTime || '-',
				});
			}
		},
		customerInfoClick(item) {
			if (item.id == 7) {
				window.open(`//${item.value}`);
			}
		},
		// 配置grorps
		setgroups() {
			let that = this;
			this.groups = {
				others: [
					{
						tagName: 'sky-select',
						placeholder: '全部预警',
						label: '全部预警',
						options: that.warningTypeList,
						prop: 'ruleId',
						props: {
							label: 'name',
							value: 'id',
						},
						value: '',
					},
					{
						tagName: 'sky-select',
						placeholder: '全部优先级',
						label: '全部优先级',
						options: warningPriority,
						prop: 'priority',
						value: '',
					},
					{
						tagName: 'sky-select',
						placeholder: '全部状态',
						label: '全部状态',
						options: warningStatus,
						prop: 'openFlag',
						value: '',
					},
				],
			};
		},
		// 配置 columns
		setcolumns() {
			let that = this;
			this.columns = [
				{
					label: '开启状态',
					bind: 'openFlag',
					type: 'custom',
					width: 100,
					componentName: messageSwitch,
					inactiveValue: 0,
					activeValue: 1,
					event(row, val) {
						that.openFlag = { val, ruleItemId: row.ruleItemId };
					},
				},
				{
					label: '预警',
					type: 'custInfo',
					width: 150,
					text: [
						{
							label: '',
							bind: 'ruleItemName',
						},
						{
							label: '类型',
							bind: 'ruleName',
						},
						{
							label: '优先级',
							bind: 'priorityStr',
						},
					],
				},
				{
					label: '撞线规则',
					bind: 'template',
					default: 'ruleVals',
					type: inputInsertion,
					change(val, index, row) {
						try {
							val = parseFloat(val);
							if (!val || typeof val != 'number') {
								that.$message({
									message: '请输入数值且不为空',
									type: 'warning',
								});
								return false;
							}
							let oldId = that.ruleVals.ruleItemId;
							let newId = row.ruleItemId;
							if (oldId && newId && oldId != newId) {
								that.ruleVal = [];
								that.ruleVals = {};
							}

							that.ruleVal = row.ruleVals;
							that.ruleVal[index] = val;
							that.ruleVals = {
								val: that.ruleVal,
								ruleItemId: row.ruleItemId,
							};
						} catch (error) {
							this.$message({
								message: '数值错误，请重新输入',
								type: 'warning',
							});
						}
					},
				},
				{
					label: '操作',
					type: 'btnClick',
					width: 100,
					align: 'center',
					bind: [
						{
							text: '保存',
							loading: true,
							async trigger(val, self) {
								let { openFlag, ruleVals, ruleVal } = that;
								// 数值校验
								if (ruleVal.length != 0) {
									if (!that.verifyData(ruleVals)) return false;
								}

								let { id, ruleId, ruleItemId } = val;
								let param = {
									ruleId,
									ruleItemId,
									serverId: that.serviceDetail.id,
									serviceId: that.serviceDetail.serviceId,
								};
								// 传值判断
								if (id) {
									param.id = id;
								}
								if (openFlag.ruleItemId == val.ruleItemId) {
									param.openFlag = openFlag.val;
								} else {
									param.openFlag = val.openFlag;
								}
								if (ruleVals.ruleItemId == val.ruleItemId) {
									param.ruleVals = ruleVals.val;
								} else {
									param.ruleVals = val.ruleVals;
								}
								let res = await googleAds.editMonitoringRules(param);
								if (res.status == 200) {
									that.$message({
										message: '保存成功',
										type: 'success',
									});
								} else {
									that.$message({
										message: '保存异常，请重试',
										type: 'warning',
									});
								}
								self.loading = false;
							},
						},
					],
				},
			];
		},
		// 配置formData
		setformData(val) {
			this.formData = {
				// kpi: {
				//   before: '￥',
				//   after: '/天',
				//   type: 'custom',
				//   formType: googleAdsIput,
				//   value: val.kpi || '',
				//   placeholder: '请输入',
				//   label: '预算',
				//   labelWidth: '85px',
				//   defaultKey: this.defaultKey,
				//   options: [],
				//   rules: [validRequired('此项必填', 'blur')]
				// },
				inquiryCost: {
					before: '￥',
					after: '/个',
					type: 'custom',
					formType: googleAdsIput,
					value: val.inquiryCost || '',
					placeholder: '请输入',
					label: '询盘成本',
					labelWidth: '120px',
					defaultKey: this.defaultKey,
					options: [],
					rules: [validRequired('此项必填', 'blur')],
				},
			};
		},
		// 选择状态
		selectChange(val) {
			this.tempStatus = this.statusValue;
			this.statusValue = val;
		},
		// 取消切换状态
		cancelStatus() {
			this.showCutStatusVal = false;
			this.statusValue = this.tempStatus;
		},
		// 改变状态
		async changeStatus() {
			try {
				let val = this.statusValue;
				let { serviceId } = this.serviceDetail;
				let res = await googleAds.setserviceStatus({
					activeStatus: val,
					serviceId,
				});
				if (res) {
					this.showCutStatusVal = false;
					this.getServiceDetail();
					this.$message({
						message: '已修改',
						type: 'success',
						duration: 1500,
					});
				} else {
					this.statusValue = this.tempStatus;
				}
			} catch (error) {
				this.statusValue = this.tempStatus;
				this.$message({
					message: '修改失败',
					type: 'warning',
					duration: 1500,
				});
			}
		},
		// 监测设置
		async setSupervise() {
			this.superviseLoading = true;
			this.$refs.rules.query();
			let { id } = this.serviceDetail;
			let res = await googleAds.budgetCost(id);
			if (res.status != 200) {
				return false;
			}
			let kpi = res.data && res.data.kpi;
			let inquiryCost = res.data && res.data.inquiryCost;
			this.setformData({
				kpi,
				inquiryCost,
			});
			this.showDoalog = true;
			this.superviseLoading = false;
		},
		// 保存预算和成本
		async saveCost() {
			try {
				let { id, formData, disabled } = this;
				if (!disabled) return false;
				this.disabled = false;
				let kpi = formData.kpi.value;
				let inquiryCost = formData.inquiryCost.value;
				await googleAds.updateCost({
					id,
					kpi,
					inquiryCost,
				});
				this.disabled = true;
				this.$message({
					message: '操作成功',
					type: 'success',
				});
			} catch (error) {
				this.disabled = true;
				this.$message({
					message: '操作失败，请重试',
					type: 'warning',
				});
			}
		},
		// 数值校验
		verifyData(ruleVals) {
			if (!ruleVals.val || ruleVals.val.length == 0) {
				this.$message({
					message: '请修改数据，值不可以为空',
					type: 'warning',
				});
				return false;
			}
			let arrVal = ruleVals.val.filter(item => !item || typeof item != 'number');
			if (arrVal.length != 0) {
				this.$message({
					message: '请输入数值且不为空',
					type: 'warning',
				});
				return false;
			}
			return true;
		},
		// 跳转预警日志
		skipLog() {
			const row = this.$route.query;
			this.$router.push({
				name: 'warningLog',
				query: {
					serviceId: row.serviceId,
				},
			});
		},
		skipWarning(val) {
			const row = this.$route.query;
			this.$router.push({
				name: 'warningList',
				query: {
					type: val,
					solve: '0',
					customerId: row.customerId,
					serviceId: row.serviceId,
				},
			});
		},
		showCutStatus() {
			this.showCutStatusVal = true;
			// this.tempStatus = this.statusValue
		},
		setAttributes() {
			this.attributes = {
				width: '40%',
				title: 'W5（2020-01-27至2020-02-02）',
				showTitle: false,
				showShadow: false,
				apiConf: '',
				condition: {},
				extend: {
					tooltip: {
						show: true,
					},
					radar: {
						radius: '60%',
						shape: 'circle',
						name: {
							show: true,
						},
					},
				},
				chartConfig: {
					type: 'veRadar',
					// "legend-visible": false,
					columns: ['日期', '访问用户', '下单用户', '地区', '下单率'],
					chartSettings: {
						labelMap: {
							日期: 'date',
							访问用户: 'PV',
							下单用户: 'Order',
							下单率: 'orderRate',
							地区: 'region',
						},
						areaStyle: {
							options: 0.3,
						},
					},
				},
				chartData: [
					{
						日期: '1/1',
						访问用户: 1393,
						下单用户: 1093,
						地区: 35,
						下单率: 0.32,
					},
					{
						日期: '1/2',
						访问用户: 3530,
						下单用户: 3230,
						地区: 323,
						下单率: 0.26,
					},
					{
						日期: '1/3',
						访问用户: 2923,
						下单用户: 2623,
						地区: 262,
						下单率: 0.76,
					},
					{
						日期: '1/4',
						访问用户: 1723,
						下单用户: 1423,
						地区: 142,
						下单率: 0.49,
					},
					{
						日期: '1/5',
						访问用户: 3792,
						下单用户: 3492,
						地区: 349,
						下单率: 0.323,
					},
					{
						日期: '1/6',
						访问用户: 4593,
						下单用户: 4293,
						地区: 429,
						下单率: 0.78,
					},
				],
			};
		},
		setDateAttributes() {
			this.dateAttributes = {
				width: '40%',
				groups: timeSwitch,
				lastDay: true,
				timeType: 'date',
				reportData: this.exportFile,
			};
		},
		exportFile() {
			console.log('导出文件');
		},
	},
	components: {
		...components,
		skySelect,
		clientModule,
		monitoringRules,
		dateSwitchSelector,
		overview,
		sticky,
	},
};
</script>

<style lang="scss" scope>
.service-default {
  position: relative;

  .header-title {
    height: 60px;
    padding: 0 10px;
    background-color: #fff;

    .title-item {
      flex: 1;
      height: 100%;
      display: flex;
      justify-content: flex-start;
      align-items: center;

      .status {
        width: 72px;
        height: 34px;
        text-align: center;
        line-height: 34px;
        color: #fff;
        font-size: 16px;
        font-weight: normal;
        background-color: #ffce3d;
        border-radius: 4px;
        margin-right: 16px;

        &.huoyue {
          background-color: #188343;
        }

        &.zanting {
          background-color: #757575;
        }

        &.siwang {
          background-color: #c3322a;
        }
      }

      .customer-name,
      .sum {
        margin-left: 16px;
        font-size: 22px;
        font-weight: bold;
        color: #333;
      }

      .sum {
        font-weight: normal;
        margin-right: 16px;
      }

      .cutStatus {
        margin-left: 10px;
        font-size: 14px;
        color: #409eff;
        line-height: 20px;
        cursor: pointer;
        user-select: none;

        i {
          font-size: 12px;
        }
      }
    }

    .title-info {
      justify-content: flex-end;
    }
  }

  .customer-info-list {
    flex-wrap: wrap;
    height: 100px;
    background-color: #fff;
    margin-top: 10px;
    padding: 10px 10px;
  }

  .date-switch {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 10px 0;
    padding-right: 24px;
    background-color: #fff;
    box-shadow: 0 8px 8px 0 rgba(67, 93, 255, 0.05);
  }

  .overview {
    background-color: #fff;
    margin-top: 10px;
    text-align: center;

    .module-main {
      padding: 10px;
      padding-bottom: 20px;
    }

    .pad10 {
      padding: 0 10px;
    }

    .displayFlex {
      display: flex;
      justify-content: space-around;
      align-items: center;
    }

    .warning-left {
      flex: 1;
      height: 200px;
      border-right: 1px solid #ccc;

      .number {
        line-height: 160px;
        font-size: 36px;
      }

      .title {
        height: 50px;
        line-height: 50px;
      }

      .data-box {
        height: 100%;
        background-color: #fff;

        .number {
          width: 100%;
          line-height: 110px;
          font-size: 36px;

          .unit {
            // margin-left: 10px;
            font-size: 14px;
          }
        }

        .bottom {
          height: 50px;
          line-height: 50px;
          border-top: 1px solid #ccc;
          display: flex;
          justify-content: space-between;
          align-items: center;

          .rate {
            border-right: 1px solid #ccc;
          }

          .period,
          .rate {
            flex: 1;
          }
        }
      }
    }

    .warning-right {
      flex: 2;
      height: 200px;
      display: flex;
      justify-content: space-around;
      align-items: center;

      .el-card {
        flex: 1;
        height: 160px;
        margin: 0 20px;
        user-select: none;
        cursor: pointer;
        box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.1);

        .number {
          height: 50%;
          line-height: 95px;
          font-size: 36px;
        }

        .title,
        .hint {
          font-size: 13px;
          height: 20px;
          line-height: 20px;
        }

        .hint {
          color: #999;
        }
      }

      .el-card:hover {
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      }
    }
  }

  .statusDialog {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    .hint {
      font-size: 16px;
    }
  }
}
</style>
